// extracted by mini-css-extract-plugin
module.exports = {"allInsightsRow":"QnTC_3V1","allInsightsLabel":"L78LqZCU","assetList":"NdU0YVOG","assetRow":"WnTtWkyv","checkboxWrapper":"MrQXjqWR","entityName":"WmAAavlA"};